import { activosCatalogScope } from './activosCatalogIdentity.js';
import { visitaOfflineContextScope } from './visitaOfflineContext.js';

export const VISITA_ASSIGNMENT_SIGNAL = 'visitas:assignment-signal';

// El mensaje solo pide revalidar; nunca incorpora activos ni permisos de su payload.
export function emitVisitaAssignmentSignal(message,user,target=typeof window==='undefined'?null:window) {
    const scope=activosCatalogScope(user),contextScope=visitaOfflineContextScope(user),payload=message?.payload;
    if((!scope&&!contextScope)||!target||!['visitas.assignments.changed','realtime.connected'].includes(message?.event)
        ||Number(payload?.user_id??message.user_id)!==Number(user.id)
        ||Number(payload?.empresa_id??message.empresa_id)!==Number(user.empresa_id))return false;
    target.dispatchEvent(new CustomEvent(VISITA_ASSIGNMENT_SIGNAL,{detail:{scope,contextScope,visitaId:Number(payload?.visita_id)||null,changed:message.event==='visitas.assignments.changed'}}));
    return true;
}

export function createAssignmentPreparation({catalog,daily,branches,isAvailable,now=Date.now,setTimer=setTimeout,clearTimer=clearTimeout}) {
    let disposed=false,timer=null,running=null,dirty=false,lastAttempt=0,retryForced=false;
    const run=()=>{
        if(disposed||running||!dirty||!isAvailable())return running||Promise.resolve();
        const delay=retryForced?0:Math.max(0,lastAttempt+30000-now());
        if(delay){schedule(delay);return Promise.resolve();}
        dirty=false;retryForced=false;lastAttempt=now();
        running=(async()=>{
            const result=await catalog.refreshScope();
            if(disposed||!isAvailable()||!result)return;
            // El alcance incluye sucursales históricas. La preparación diaria y las
            // lecturas de listas cubren las actuales; descargar puntualmente solo altas nuevas.
            await branches.observe(result.addedSucursalIds||[]);
            if(disposed||!isAvailable())return;
            if(result.needsLists){
                const refreshed=await daily.run({assignmentsChanged:true});
                if(!disposed&&isAvailable()&&refreshed?.complete)await catalog.markListsPrepared(result.version);
            }
        })().catch(()=>{/* La copia anterior se conserva; retoma con otro evento o al volver. */})
            .finally(()=>{running=null;if(dirty&&!disposed&&isAvailable())schedule(retryForced?750:Math.max(750,lastAttempt+30000-now()));});
        return running;
    };
    const schedule=delay=>{if(timer!==null)clearTimer(timer);timer=setTimer(()=>{timer=null;void run();},delay);};
    return {request({changed=false}={}){if(disposed)return;dirty=true;retryForced=retryForced||changed;if(isAvailable())schedule(changed?750:0);},run,dispose(){disposed=true;if(timer!==null)clearTimer(timer);}};
}
